(function () {
'use strict';
if (!document.getElementById('smd-mf') || !window.SMDMotorFinder) return;
var A = window.SMDMotorFinder, MOTORS = A.MOTORS, CATS = A.CATS, POWER = A.POWER, CONTROL = A.CONTROL, SUPPORT = A.SUPPORT,
inCat = A.inCat, pool = A.pool, choicesFor = A.choicesFor, recommend = A.recommend, matchPart = A.matchPart, summary = A.summary;
var root = document.getElementById('smd-mf');
var panel = root.querySelector('.smd-mf-panel');
var log = root.querySelector('.smd-mf-log');
var input = root.querySelector('.smd-mf-input');
var launch = root.querySelector('.smd-mf-launch');
var st = {}, started = false, busy = false;
function el(tag, cls, html) { var e = document.createElement(tag); if (cls) e.className = cls; if (html != null) e.innerHTML = html; return e; }
function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
function scroll() { log.scrollTop = log.scrollHeight; }
function user(text) { log.appendChild(el('div', 'mf-msg mf-user', esc(text))); scroll(); }
function bot(html, cb) {
busy = true; input.innerHTML = '';
var t = el('div', 'mf-msg mf-bot', '<span class="mf-typing"><i></i><i></i><i></i></span>');
log.appendChild(t); scroll();
var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
setTimeout(function () { t.innerHTML = html; scroll(); busy = false; if (cb) cb(); }, reduce ? 0 : 450);
}
function chips(list, onPick) {
input.innerHTML = '';
list.forEach(function (c) {
var b = el('button', 'mf-chip', esc(c.label) + (c.note ? '<small>' + esc(c.note) + '</small>' : ''));
b.type = 'button';
b.addEventListener('click', function () { if (busy) return; user(c.label); onPick(c.id); });
input.appendChild(b);
});
}
var bound = false, binding = false, waiting = [];
function flush() { var w = waiting; waiting = []; w.forEach(function (fn) { fn(); }); }
function protect(cb) {
if (cb) waiting.push(cb);
if (bound) { flush(); return; }
if (binding) return;
binding = true;
var done = function () { if (bound) return; bound = true; flush(); };
var hf = document.getElementById('smd-mf-contact-form');
try { if (hf && window.Shopify && Shopify.captcha && Shopify.captcha.protect) Shopify.captcha.protect(hf, done); else done(); } catch (err) { done(); }
setTimeout(done, 6000);
}
function posted() {
var email = ''; try { email = sessionStorage.getItem('smdmf_sent') || ''; } catch (e) {}
if (!email || !/[?&]contact_posted=true/.test(location.search)) return;
try { sessionStorage.removeItem('smdmf_sent'); } catch (e) {}
try { history.replaceState(null, '', location.pathname + location.search.replace(/([?&])contact_posted=true&?/, '$1').replace(/[?&]$/, '')); } catch (e) {}
started = true; root.classList.add('is-open'); panel.hidden = false;
bot('Got it. Your answers are with our Somfy experts, and we\'ll reply to ' + esc(email) + ' during support hours, ' + SUPPORT.hours + '.', function () {
chips([{ id: 'restart', label: 'Start over' }], function () { log.innerHTML = ''; begin(); });
});
}
function open() {
root.classList.add('is-open'); panel.hidden = false;
if (!started) { started = true; begin(); }
protect();
var f = panel.querySelector('button, input'); if (f) f.focus();
}
function close() { root.classList.remove('is-open'); panel.hidden = true; launch.focus(); }
launch.addEventListener('click', open);
root.querySelector('[data-mf-close]').addEventListener('click', close);
root.querySelector('[data-mf-restart]').addEventListener('click', function () { log.innerHTML = ''; begin(); });
document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !panel.hidden) close(); });
function begin() {
st = { simu: false };
bot('Hi! Answer a few quick questions and I\'ll match you with the right Somfy motor. What are you motorizing?', function () {
chips(CATS, function (id) { st.cat = id; next(); });
});
}
function askOne(key, prompt) {
var opts = choicesFor(st, key), map = key === 'power' ? POWER : CONTROL;
if (!opts.length) { noMatch(); return; }
if (opts.length === 1) { st[key] = opts[0]; next(); return; }
bot(prompt, function () {
chips(opts.map(function (k) { return { id: k, label: map[k][0], note: map[k][1] }; }), function (id) { st[key] = id; next(); });
});
}
function next() {
var c = st.cat;
if (c === 'replace') return askPart();
if (c === 'exterior' && !st.sub) {
return bot('Which one is it?', function () {
chips([{ id: 'screen', label: 'Exterior solar screen', note: 'Fabric screen' }, { id: 'shutter', label: 'Rolling shutter', note: 'Aluminum or vinyl slats' }], function (id) { st.sub = id; next(); });
});
}
if (c !== 'pergola' && c !== 'tilt' && c !== 'cellular' && c !== 'awning' && !st.power) return askOne('power', 'How will the motor get power?');
if (c !== 'pergola' && !st.control) return askOne('control', 'How do you want to control it?');
if ((c === 'roller' || c === 'exterior') && !st.w) return askSize();
if (c === 'awning' && !st.w) return askAwning();
if (c === 'drapery' && !st.track && !st.lb) return askDrapery();
showResults();
}
function formMsg(html, fields, submitLabel, onSubmit) {
input.innerHTML = '';
var f = el('form', 'mf-form', html); f.noValidate = true;
var err = el('div', 'mf-err'); f.appendChild(err);
var b = el('button', 'mf-btn', esc(submitLabel)); b.type = 'submit'; f.appendChild(b);
f.addEventListener('submit', function (e) {
e.preventDefault(); err.textContent = '';
var v = {}; fields.forEach(function (n) { var x = f.elements[n]; v[n] = x ? x.value.trim() : ''; });
var msg = onSubmit(v, f); if (msg) err.textContent = msg;
});
input.appendChild(f);
var first = f.querySelector('input, select, textarea'); if (first) first.focus();
}
function num(v) { var n = parseFloat(String(v).replace(',', '.')); return isFinite(n) && n > 0 ? n : null; }
function askSize() {
var fabric = st.cat === 'roller'
? '<label>Fabric<select name="fabric"><option value="light">Light: sheer or 1-5% solar</option><option value="medium" selected>Medium: light filtering</option><option value="heavy">Heavy: blackout or thermal</option></select></label>' : '';
bot('How big is the shade? Use the fabric size, in inches.', function () {
formMsg('<div class="mf-row"><label>Width (in)<input name="w" inputmode="decimal" placeholder="72"></label><label>Height (in)<input name="h" inputmode="decimal" placeholder="84"></label></div>' + fabric,
['w', 'h', 'fabric'], 'Find my motor', function (v) {
var w = num(v.w), h = num(v.h);
if (!w || !h) return 'Enter both width and height in inches.';
if (w > 480 || h > 480) return 'That looks larger than 40 ft. Double-check it is in inches.';
st.w = w; st.h = h; st.fabric = v.fabric || null;
user(w + ' in x ' + h + ' in' + (st.fabric ? ', ' + st.fabric + ' fabric' : '')); next();
});
});
}
function askAwning() {
bot('How big is the awning, in feet?', function () {
formMsg('<div class="mf-row"><label>Width (ft)<input name="w" inputmode="decimal" placeholder="12"></label><label>Projection (ft)<input name="proj" inputmode="decimal" placeholder="10"></label></div><div class="mf-note">Projection is how far it sticks out from the wall.</div>',
['w', 'proj'], 'Find my motor', function (v) {
var w = num(v.w), p = num(v.proj);
if (!w || !p) return 'Enter both width and projection in feet.';
st.w = w; st.proj = p; user(w + ' ft wide x ' + p + ' ft projection'); next();
});
});
}
function askDrapery() {
bot('How long is the track, and how heavy are the curtains?', function () {
formMsg('<label>Track length (ft)<input name="track" inputmode="decimal" placeholder="10"></label><label>Curtain weight<select name="weight"><option value="light">Light: sheers</option><option value="medium" selected>Medium: lined curtains</option><option value="heavy">Heavy: blackout, velvet, interlined</option></select></label><label>Know the exact weight? (lb, optional)<input name="lb" inputmode="decimal" placeholder="Optional"></label>',
['track', 'weight', 'lb'], 'Find my motor', function (v) {
var t = num(v.track), lb = num(v.lb);
if (!t && !lb) return 'Enter the track length.';
st.track = t; st.weight = v.weight; st.lb = lb;
user((t ? t + ' ft track, ' : '') + (lb ? lb + ' lb curtains' : v.weight + ' curtains')); next();
});
});
}
function askPart() {
bot('What does the label on the old motor say? The part number is usually 7 digits, like 1001809.', function () {
formMsg('<label>Part number or label text<input name="part" placeholder="e.g. 1001809 or Sonesse 506S2 RTS"></label>', ['part'], 'Look it up', function (v) {
if (!v.part) return 'Type what you can read on the label.';
st.part = v.part; user(v.part);
var m = matchPart(v.part);
if (m) {
st.results = [m.sku];
bot('Found it. This is the same part number we sell:', function () {
renderCards([m], null); afterResults(true);
});
} else {
bot('I couldn\'t match that one. Old and discontinued motors often have a newer replacement, and our team can tell you which. Send your details to our team and we\'ll take it from here.', offer);
}
});
});
}
function noMatch() {
bot('None of our motors fit that combination. Send your answers to our team and we\'ll find the right setup.', offer);
}
function showResults() {
var r = recommend(st);
if (!r.items.length) {
if (!st.simu && pool({ cat: st.cat, simu: true, power: st.power, control: st.control }).some(function (m) { return m.simu; })) {
st.simu = true; var r2 = recommend(st);
if (r2.items.length) return present(r2, true);
st.simu = false;
}
return bot((r.need ? 'That size needs more power than these motors give. ' : '') + 'Let our team size this one for you.', offer);
}
present(r, false);
}
function present(r, simuOnly) {
st.results = r.items.map(function (m) { return m.sku; });
var intro = r.items.length > 1 ? 'Here are your best matches. The first one is the closest fit.' : 'Here\'s your best match.';
if (simuOnly) intro = 'Our Simu line by Somfy covers this one:';
var need = r.need ? '<div class="mf-note">Estimated need: about ' + (r.unit === 'Nm' ? r.need.toFixed(1) + ' Nm of torque' : Math.round(r.need) + ' lb of curtain') + '. Estimates assume a standard tube and fabric, so check with us if your shade is unusual.</div>' : '';
bot(intro + need, function () { renderCards(r.items, r); afterResults(false); });
}
function why(m, r) {
if (!r || !r.need) {
if (m.kit) return 'Complete kit: motor, remote and charger options in one listing.';
return CONTROL[m.control][0] + ', ' + POWER[m.power][0].toLowerCase();
}
if (r.unit === 'Nm') return m.torque + ' Nm motor, ' + CONTROL[m.control][0];
return 'Carries up to ' + m.load + ' lb, ' + CONTROL[m.control][0];
}
function money(cents) { return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
function renderCards(items, r) {
var wrap = el('div', 'mf-cards'); log.appendChild(wrap);
items.forEach(function (m, i) {
var card = el('div', 'mf-card' + (i === 0 ? ' top' : ''), '<div></div><div><div class="mf-note">Loading...</div></div>');
wrap.appendChild(card);
fetch('/products/' + m.handle + '.js').then(function (res) { if (!res.ok) throw 0; return res.json(); }).then(function (p) {
var v = p.variants.filter(function (x) { return x.available; })[0] || p.variants[0];
var img = p.featured_image ? p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=160' : '';
card.innerHTML = (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '<div></div>') +
'<div>' + (i === 0 ? '<span class="mf-badge">Best match</span>' : '') +
'<h4><a href="' + esc(p.url || '/products/' + m.handle) + '">' + esc(p.title) + '</a></h4>' +
'<div class="mf-why">' + esc(why(m, r)) + '</div>' +
'<div class="mf-card-foot"><span class="mf-price">' + money(v.price) + '</span>' +
'<a class="mf-link" href="' + esc(p.url || '/products/' + m.handle) + '">Details</a>' +
(v.available !== false ? '<button type="button" class="mf-btn" data-id="' + v.id + '">Add to cart</button>' : '<span class="mf-note">Call for availability</span>') +
'</div></div>';
var btn = card.querySelector('button[data-id]');
if (btn) btn.addEventListener('click', function () { addToCart(btn); });
scroll();
}).catch(function () {
card.innerHTML = '<div></div><div><h4><a href="/products/' + esc(m.handle) + '">View part ' + esc(m.sku) + '</a></h4></div>';
});
});
scroll();
}
function addToCart(btn) {
btn.disabled = true; btn.textContent = 'Adding...';
fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(btn.getAttribute('data-id')), quantity: 1 }] }) })
.then(function (res) { if (!res.ok) throw 0; return res.json(); })
.then(function () {
var a = el('a', 'mf-btn alt', 'View cart'); a.href = '/cart'; btn.replaceWith(a);
document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
})
.catch(function () { btn.disabled = false; btn.textContent = 'Try again'; });
}
function afterResults(fromPart) {
var list = [];
var hasSimu = !st.simu && !fromPart && st.cat !== 'replace' && MOTORS.some(function (m) { return m.simu && inCat(m, st.cat); });
if (hasSimu) list.push({ id: 'simu', label: 'Show Simu options too', note: 'Somfy\'s Simu line' });
list.push({ id: 'chat', label: 'Send my answers to our team', note: 'Opens live chat with your answers filled in' });
list.push({ id: 'email', label: 'Email them instead' });
list.push({ id: 'restart', label: 'Start over' });
chips(list, function (id) {
if (id === 'simu') { st.simu = true; showResults(); }
else if (id === 'chat') handoff();
else if (id === 'email') expertForm();
else { log.innerHTML = ''; begin(); }
});
}
function offer() {
chips([{ id: 'chat', label: 'Send my answers to our team', note: 'Opens live chat with your answers filled in' }, { id: 'email', label: 'Email them instead' }], function (id) { if (id === 'chat') handoff(); else expertForm(); });
}
function handoff() {
var text = summary(st).replace('Motor Finder answers:', 'Hi, I used the Motor Finder. My answers:');
close();
A.sendToChat(text).catch(function () { open(); bot('Chat didn\'t open. Leave your email and we\'ll reply.', expertForm); });
}
function expertForm() {
bot('Leave your email and our Somfy experts will review your answers and reply.', function () {
formMsg('<label>Name<input name="name" autocomplete="name"></label><label>Email<input name="email" type="email" autocomplete="email" required></label><label>Phone (optional)<input name="phone" type="tel" autocomplete="tel"></label><label>Anything else? (optional)<textarea name="notes" rows="3" placeholder="Old motor model, photos you can send, window details..."></textarea></label>',
['name', 'email', 'phone', 'notes'], 'Send to an expert', function (v, f) {
if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v.email)) return 'Enter a valid email so we can reply.';
var body = summary(st) + (v.notes ? '\n\nCustomer notes: ' + v.notes : '') + '\n\nPage: ' + location.href;
var hf = document.getElementById('smd-mf-contact-form');
hf.elements['contact[name]'].value = v.name;
hf.elements['contact[email]'].value = v.email;
hf.elements['contact[phone]'].value = v.phone;
hf.elements['contact[body]'].value = body;
var b = f.querySelector('button[type=submit]'); b.disabled = true; b.textContent = 'Sending...';
try { sessionStorage.setItem('smdmf_sent', v.email); } catch (e) {}
protect(function () { if (hf.requestSubmit) hf.requestSubmit(); else hf.submit(); });
});
});
}
posted();
})();